class CollapsedTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".collapsed-tabs__tab-wrapper");
    if (window.innerWidth <= 830) {
      this.disableAllTabsLinks();
    }
    window.addEventListener("resize", this.onResize);
  }

  onResize = () => {
    const tabs = this.querySelectorAll(".collapsed-tabs__tab-wrapper");
    if (window.innerWidth <= 830) {
      tabs.forEach((tab) => {
        this.removeTabActiveState(tab);
      });
      this.disableAllTabsLinks();
    } else {
      tabs.forEach((tab) => {
        const tabListItems = tab.querySelectorAll("li");

        tabListItems.forEach((listItem) => {
          const link = listItem.querySelector("a");
          this.enableLink(link);
        });

        tab.classList.remove("active");

        const tabExpandableContent = tab.querySelector(
          ".collapsed-tabs__tab-inner"
        );
        tabExpandableContent.style = `max-height: fit-content;`;
      });
    }
  };

  disableAllTabsLinks() {
    const tabs = this.querySelectorAll(".collapsed-tabs__tab-wrapper");

    for (const tab of tabs) {
      const tabListItems = tab.querySelectorAll("li");
      for (const listItem of tabListItems) {
        this.disableLink(listItem.querySelector("a"));
      }
    }
  }

  disableLink(link) {
    link.classList.add("disabled");
    link.tabIndex = -1;
  }

  enableLink(link) {
    link.classList.remove("disabled");
    link.tabIndex = 0;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll(".collapsed-tabs__tab-wrapper");
    this.tabs.forEach((tab) => {
      this.heading = tab.querySelector(".collapsed-tabs__title-mobile");
      const tabExpandableContent = tab.querySelector(
        ".collapsed-tabs__tab-inner"
      );
      if (!tabExpandableContent) {
        return (tab.style.display = "none");
      }
      tabExpandableContent.ariaHidden = true;

      this.heading.addEventListener("click", () => {
        if (tab.classList.contains("active")) {
          this.removeTabActiveState(tab);
        } else {
          this.showTabDescription(tab);
        }
      });

      // Description has to be always expanded
      if (tab.id === "description") {
        tab.click();
      }
    });
  }

  getTallestChildHeight(wrapper) {
    if (!wrapper || wrapper.children.length === 0) {
      return 0; // Return 0 if no wrapper or no children
    }

    // Initialize the tallest height found to 0
    let tallestHeight = 0;

    for (const child of wrapper.children) {
      const childHeight = child.offsetHeight;

      if (childHeight > tallestHeight) {
        tallestHeight = childHeight;
      }
    }

    return tallestHeight;
  }

  removeTabActiveState = (tab) => {
    tab.classList.remove("active");
    const tabExpandableContent = tab.querySelector(
      ".collapsed-tabs__tab-inner"
    );
    if (tabExpandableContent) {
      tabExpandableContent.ariaHidden = true;
      tabExpandableContent.classList.remove(
        "collapsed-tabs__tab-inner--expanded"
      );
      const tabListItems = tab.querySelectorAll("li");
      for (const listItem of tabListItems) {
        this.disableLink(listItem.querySelector("a"));
      }
      tabExpandableContent.classList.add(
        "collapsed-tabs__tab-inner--collapsed"
      );
      tabExpandableContent.style = `max-height: 0px;`;
    }
  };

  assignStylesToChild = (child) => {
    if (child.tagName === "P") {
      child.classList.add("collapsed-tabs__child-p");
    }

    child.classList.add("collapsed-tabs__child");
  };

  assignStylesToChildren = (children) =>
    Array.from(children).forEach((child) => {
      if (child.children.length) {
        this.assignStylesToChildren(child.children);
      } else {
        this.assignStylesToChild(child);
      }
    });

  showTabDescription = (tab) => {
    tab.classList.add("active");

    const tabExpandableContent = tab.querySelector(
      ".collapsed-tabs__tab-inner"
    );
    if (!tabExpandableContent) return;

    tabExpandableContent.ariaHidden = false;
    this.assignStylesToChildren(tabExpandableContent.children);

    const CONTENT_PADDING_PX = 34;
    const tabDescriptionHeight =
      this.getTallestChildHeight(tabExpandableContent) + CONTENT_PADDING_PX;

    tabExpandableContent.classList.add("collapsed-tabs__tab-inner--expanded");

    const tabListItems = tab.querySelectorAll("li");
    for (const listItem of tabListItems) {
      const link = listItem.querySelector("a");
      this.enableLink(link);
    }

    tabExpandableContent.classList.remove(
      "collapsed-tabs__tab-inner--collapsed"
    );

    tabExpandableContent.style = `max-height: ${tabDescriptionHeight}px;`;
  };

  disconnectedCallback() {}
}

customElements.define("collapsed-tabs", CollapsedTabs);
